"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cssProperties = exports.StyleContainer = exports.StackStyleSet = exports.RootStyle = exports.FontStyle = exports.CompositeStyleSet = exports.ClassStyle = exports.BlockTypeStyle = exports.BaseStyleSet = void 0;
exports.cssToStyle = cssToStyle;
exports.parseGradientSteps = parseGradientSteps;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _PropertyFactory = require("./properties/PropertyFactory");
var _remeda = require("remeda");
const cssProperties = exports.cssProperties = new _PropertyFactory.PropertyFactory();
const unitRegex = /^(\d*\.?\d*)([a-z%]*)?$/;
function splitBySeparator(value, sep) {
  let layers = [];
  let layer = "";
  let depth = 0;
  for (let it of value) {
    if (it === sep) {
      if (depth < 1) {
        layers.push(layer.trim());
        layer = "";
        continue;
      }
    } else if (it === "(") {
      ++depth;
    } else if (it === ")") {
      --depth;
    }
    layer += it;
  }
  if (layer.length > 0) {
    layers.push(layer.trim());
  }
  return layers;
}
function parseGradientSteps(value) {
  if (!value) {
    return [];
  }
  let steps = [];
  let values = splitBySeparator(value, ",");
  for (let it of values) {
    let parts = splitBySeparator(it.trim(), " ");
    let pos = -1;
    if (parts[1]) {
      pos = parseInt(parts[1].slice(0, -1));
    }
    steps.push({
      color: parts[0],
      pos
    });
  }
  let missing = [];
  let start = 0;
  for (let i = 0; i < steps.length; i++) {
    if (steps[i].pos === -1) {
      if (i === 0) {
        steps[i].pos = 0;
      } else if (i === steps.length - 1) {
        steps[i].pos = 100;
      } else {
        missing.push(steps[i]);
        continue;
      }
    }
    if (missing.length > 0) {
      let end = steps[i].pos;
      let inc = (end - start) / (missing.length + 1);
      let j = 1;
      for (let it of missing) {
        it.pos = start + Math.round(j * inc);
        ++j;
      }
      missing = [];
    }
    start = steps[i].pos;
  }
  return steps;
}
class StyleContainer {
  constructor() {
    (0, _defineProperty2.default)(this, "props", {});
  }
  static fromJson(data) {
    let container = new StyleContainer();
    for (let [key, val] of Object.entries(data)) {
      // Remove remains of individual properties that belong in composite properties
      if (!cssProperties.compositeProperties.includes(key)) {
        container.set(key, val);
      }
    }
    return container;
  }
  static toJSON(props) {
    let json = {};
    let entries = Object.entries(props);
    entries.sort((a, b) => a[0].localeCompare(b[0]));
    for (let [property, entry] of entries) {
      if (entry.type === "composite") {
        json[property] = entry.values.map(it => it.fixedValue || it.value + (it.unit || "")).join(" ");
      } else if (entry.type === "stack") {
        let prop = cssProperties.get(property);
        json[property] = entry.values.map(layer => {
          if (property === "background" && layer.length > 3) {
            let vals = layer.map(it => it.fixedValue || it.value + (it.unit || ""));
            if (vals.length > 4) {
              if (vals[3] === "cover" || vals[3] === "contain") {
                vals.splice(4, 1);
              }
            }
            vals.splice(3, 0, "/");
            return vals.join(" ");
          }
          return layer.map(it => it.fixedValue || it.value + (it.unit || "")).join(" ");
        }).join(prop.layerSeparator || ",");
      } else {
        json[property] = entry.fixedValue || entry.value + (entry.unit || "");
      }
    }
    return json;
  }
  parseValue(prop, input) {
    let value = input.trim();
    if (!prop.type) {
      throw new Error("No prop type in parseValue");
    }
    if (prop.fixedValues && prop.fixedValues.includes(value)) {
      return {
        type: prop.type,
        fixedValue: value
      };
    } else if (prop.units) {
      let parsed = unitRegex.exec(value);
      if (parsed) {
        return {
          type: prop.type,
          value: parsed[1],
          unit: parsed[2]
        };
      } else {
        return {
          type: prop.type,
          value
        };
      }
    } else {
      return {
        type: prop.type,
        value
      };
    }
  }
  get(property) {
    return this.props[property];
  }
  setEntry(entry) {
    this.props[entry.property] = entry;
  }
  remove(property) {
    delete this.props[property];
  }
  set(property, value) {
    let prop = cssProperties.get(property);
    if (!prop) {
      throw new Error("No property found for " + property);
    }
    if (prop.type === "composite") {
      let vals = splitBySeparator(value, " ");
      let entry = {
        type: "composite",
        property,
        values: []
      };
      let i = 0;
      for (let it of prop.properties) {
        let val = prop.uniform && vals.length === 1 ? vals[0] : vals[i];
        if (val !== undefined) {
          entry.values.push({
            ...this.parseValue(it, val)
          });
        }
        ++i;
      }
      this.props[property] = entry;
    } else if (prop.type === "stack") {
      let entry = {
        property,
        type: "stack",
        values: []
      };
      let layers = splitBySeparator(value, prop.layerSeparator || ",");
      for (let layer of layers) {
        let vals = splitBySeparator(layer, " ");
        let i = 0;
        let layerValues = [];
        if (prop.property === "background") {
          // url("../../media/examples/lizard.png") no-repeat center / 50% scroll;
          // radial-gradient(crimson, skyblue) no-repeat center left / 50% 50%;
          // Image
          layerValues.push({
            type: "file",
            value: vals.shift()
          });
          if (vals.length > 0) {
            // repeat
            layerValues.push({
              type: "select",
              value: vals.shift()
            });
            if (vals.length > 0) {
              // position
              layerValues.push({
                type: "select",
                value: vals.shift() + " " + vals.shift()
              });
              if (vals.length > 0) {
                // slash
                vals.shift();

                // Size
                layerValues.push(this.parseValue(prop.properties[3], vals.shift()));
                if (vals.length > 0) {
                  // Size y
                  layerValues.push(this.parseValue(prop.properties[4], vals.shift()));
                }
              }
            }
          }
        } else {
          for (let it of prop.properties) {
            let val = vals[i];
            if (val) {
              layerValues.push(this.parseValue(it, val));
            }
            ++i;
          }
        }
        entry.values.push(layerValues);
      }
      this.props[property] = entry;
    } else {
      this.props[property] = {
        ...this.parseValue(prop, value),
        property
      };
    }
  }
  toJSON() {
    return StyleContainer.toJSON(this.props);
  }
  toCss() {
    return Object.entries(this.toJSON()).map(([prop, value]) => `${prop}:${value};`).join(" ");
  }
}
exports.StyleContainer = StyleContainer;
class BaseStyleSet {
  constructor(css) {
    (0, _defineProperty2.default)(this, "css", void 0);
    this.css = Object.freeze(css);
  }
  merge(other) {
    let merged = this.create(new StyleContainer());
    Object.assign(merged.css.props, (0, _remeda.clone)(this.css.props), (0, _remeda.clone)(other.css.props));
    return merged;
  }
  get(property) {
    var _this$css;
    return (_this$css = this.css) === null || _this$css === void 0 ? void 0 : _this$css.get(property);
  }
}
exports.BaseStyleSet = BaseStyleSet;
class FontStyle extends BaseStyleSet {
  constructor(fonts) {
    super(new StyleContainer());
    (0, _defineProperty2.default)(this, "setType", "fonts");
    (0, _defineProperty2.default)(this, "fonts", new Set());
    if (fonts) {
      for (let it of fonts) {
        this.fonts.add(it);
      }
    }
  }
  create(css) {
    return new FontStyle();
  }
  get id() {
    return "style-fonts";
  }
  toCss() {
    if (this.fonts.size > 0) {
      let fonts = Array.from(this.fonts).map(it => `family=${encodeURIComponent(it)}:ital,wght@0,400;0,700;1,400;1,700`).join("&");
      return `@import url("https://fonts.googleapis.com/css2?${fonts}&display=swap");`;
    } else {
      return "";
    }
  }
  toJSON() {
    return undefined;
  }
}
exports.FontStyle = FontStyle;
class RootStyle extends BaseStyleSet {
  get id() {
    return "Palette Root";
  }
  constructor(css) {
    super(css);
    (0, _defineProperty2.default)(this, "setType", "root");
  }
  create(css) {
    return new RootStyle(css);
  }
  toCss(prefix) {
    return `${prefix || ""} .palette-root-style { ${this.css.toCss()} }`;
  }
  toJSON() {
    return {
      css: this.css.toJSON()
    };
  }
}
exports.RootStyle = RootStyle;
let currentIndex = 1;
class ClassStyle extends BaseStyleSet {
  get id() {
    return `class: ${this.name}`;
  }
  static stateSelector(state) {
    if (state) {
      return ":" + state;
    }
    return "";
  }
  constructor(css, name, state) {
    super(css);
    (0, _defineProperty2.default)(this, "setType", "class");
    (0, _defineProperty2.default)(this, "index", currentIndex++);
    this.name = name;
    this.state = state;
  }
  create(css) {
    return new ClassStyle(css, this.name, this.state);
  }
  toCss(prefix) {
    return `${prefix || ""} .${this.name}${ClassStyle.stateSelector(this.state)}{ ${this.css.toCss()} }`;
  }
  toJSON() {
    return {
      name: this.name,
      state: this.state,
      css: this.css.toJSON()
    };
  }
}
exports.ClassStyle = ClassStyle;
class BlockTypeStyle extends BaseStyleSet {
  get id() {
    return "block: " + BlockTypeStyle.className(this.type, this.layout);
  }
  static className(type, layout) {
    if (layout) {
      return `${type}-block-layout-${layout}`;
    } else {
      return `${type}-block`;
    }
  }
  constructor(styles, type, state, layout) {
    super(styles);
    (0, _defineProperty2.default)(this, "setType", "block");
    this.type = type;
    this.state = state;
    if (layout) {
      this.layout = layout;
    }
  }
  create(css) {
    return new BlockTypeStyle(css, this.type, this.state, this.layout);
  }
  toCss(prefix) {
    let name = BlockTypeStyle.className(this.type, this.layout);
    return `${prefix || ""} .${name}${ClassStyle.stateSelector(this.state)}{ ${this.css.toCss()} }`;
  }
  toJSON() {
    let style = {
      type: this.type,
      css: this.css.toJSON()
    };
    if (this.layout) {
      style.layout = this.layout;
    }
    if (this.state) {
      style.state = this.state;
    }
    return style;
  }
}
exports.BlockTypeStyle = BlockTypeStyle;
function cssToStyle(css) {
  let reg = /\.([a-z-]+)((?:::?|\[)[a-z-=\]]+)? *\{([^}]+)}/g;
  let sets = [];
  let matches = css.matchAll(reg);
  for (let match of matches) {
    let name = match[1];
    let rawState = match[2];
    let state;
    let type;
    let layout;
    let styles = match[3];
    if (name === "palette-root-style") {
      name = null;
    } else {
      if (rawState) {
        if (rawState.startsWith(":")) {
          rawState = rawState.replace(/^::?/, "");
          if (rawState === "disabled" || rawState === "hover" || rawState === "focus") {
            state = rawState;
          }
        }
      }
      let m = /^([a-z0-9-]+)-block(?:-layout-([a-z0-9]+))?$/.exec(name);
      if (m) {
        type = m[1];
        layout = m[2];
        name = null;
      }
    }
    let container = new StyleContainer();
    for (let it of styles.split(";")) {
      it = it.trim();
      if (it) {
        let m = /^([a-z-]+):(.*)/.exec(it);
        container.set(m[1], m[2].trim());
      }
    }
    let set;
    if (name) {
      set = new ClassStyle(container, name, state);
    } else if (type) {
      set = new BlockTypeStyle(container, type, state, layout);
    } else {
      set = new RootStyle(container);
    }
    sets.push(Object.freeze(set));
  }
  return sets;
}
class CompositeStyleSet {
  get id() {
    return "composite: " + this.prop.property;
  }
  static from(entry) {
    var _entry$value;
    return Object.freeze(new CompositeStyleSet(entry.prop, (_entry$value = entry.value) === null || _entry$value === void 0 ? void 0 : _entry$value.values));
  }
  constructor(prop, values) {
    (0, _defineProperty2.default)(this, "setType", "composite");
    (0, _defineProperty2.default)(this, "values", {});
    this.prop = prop;
    if (values) {
      this.addValues(values);
    }
  }
  get(property) {
    return {
      property,
      ...this.values[property]
    };
  }
  addValues(values) {
    let i = 0;
    for (let it of values) {
      let prop = this.prop.properties[i];
      if (prop) {
        this.values[prop.property] = it;
      }
      ++i;
    }
  }
}
exports.CompositeStyleSet = CompositeStyleSet;
class StackStyleSet {
  get id() {
    return "stack: " + this.prop.property;
  }
  static from(entry) {
    var _entry$value2;
    if (!(entry !== null && entry !== void 0 && (_entry$value2 = entry.value) !== null && _entry$value2 !== void 0 && _entry$value2.values)) {
      return [];
    }
    return entry.value.values.map(it => Object.freeze(new StackStyleSet(entry.prop, it)));
  }
  constructor(prop, values) {
    (0, _defineProperty2.default)(this, "setType", "stack");
    (0, _defineProperty2.default)(this, "values", {});
    this.prop = prop;
    if (values) {
      this.addValues(values);
    }
  }
  get(property) {
    return {
      property,
      ...this.values[property]
    };
  }
  addValues(values) {
    let i = 0;
    for (let it of values) {
      let prop = this.prop.properties[i];
      if (prop) {
        this.values[prop.property] = it;
      }
      ++i;
    }
  }
  toValues() {
    return Object.fromEntries(this.prop.properties.map(it => {
      let value;
      if (this.values[it.property]) {
        let entry = this.values[it.property];
        value = entry.fixedValue || entry.value + (entry.unit || "");
      } else {
        value = it.default;
      }
      return [it.id, value];
    }));
  }
}
exports.StackStyleSet = StackStyleSet;
//# sourceMappingURL=StyleSet.js.map